<template>
	<div class="detail">
		<div class="h">
			<myheader ref="myheader"></myheader>
			<mynav></mynav>
			<div class="commoditybox">
				<div class="img_textdiv">
					<div class="img_p">
						<div class="img" @click="onxq">
							<img :src="onimgarr(list.pic)[0]" v-if="onimgarr(list.pic)[0]">
							<img v-else src="../assets/image/null.png">
							<div>点击查看商品详情</div>
						</div>
						<p>* 图片仅供参考</p>
					</div>

					<div class="textdiv">
						<div class="h4">
							{{list.brand}} {{list.sex}} {{list.cid_second}} {{list.cid_third}} {{list.style_number}}
						</div>
						<div class="jgbox">
							<div class="hyj">
								会员价:<span>￥<i>{{list.discount_price}}</i></span>起
							</div>
							<div class="dpj">
								吊牌价: {{list.price}}
							</div>
							<div class="zkk">
								{{list.discount_str}}折起
							</div>
						</div>
						<div class="parameter">
							<div>品牌:<span>{{list.brand}}</span></div>
							<div>商品大类:<span>{{list.cid_first}}</span></div>
							<div>商品中类:<span>{{list.cid_second}}</span></div>
							<div>商品小类:<span>{{list.cid_third}}</span></div>
							<div>性别:<span>{{list.sex}}</span></div>
							<div>系列:<span>{{list.series}}</span></div>
							<div>颜色:<span>{{list.color}}</span></div>
							<div>季节:<span>{{list.season}}</span></div>
						</div>
						<div class="parameter content">
							<div>描述:<span>{{list.content}}</span></div>
						</div>
					</div>
				</div>
				<div style="width: 100%; height: 54px;margin-top: 20px" ref="tab">
					<div :class="tabflexd?'tabdiv flexd':'tabdiv'">
						<el-tabs v-model="active" @tab-click="handleClick">
							<el-tab-pane label="货源库存" name="kc" v-if="islogin"></el-tab-pane>
							<el-tab-pane label="商品详情" name="xq"></el-tab-pane>
						</el-tabs>
					</div>
				</div>
				<div ref="kc" style="scroll-margin-top: 54px;margin-bottom: 16px;" v-show="islogin">
					<el-table :data="pricelist" style="width: 100%" stripe header-cell-class-name="custom-class"
						v-tableSticky.fixed="54" :cell-class-name="cellClassName">
						<el-table-column label="渠道" fixed="left" align="center" header-align="center" min-width="90px">
							<template slot-scope="scope">
								<div>{{scope.row.shop_name}}</div>
								<div class="is">
									<el-tooltip :content="scope.row.shop_qq" placement="bottom" effect="light">
										<img src="../assets/image/qq.png" @click="oncopy(scope.row.shop_qq)">
									</el-tooltip>
						
									<el-popover width="401" placement="right" trigger="click"
										@show="ongdd(scope.row.shop_id)" @hide="onhide">
										<div class="ggbox">
											<el-table :data="glist" style="width: 100%" height="calc(100% - 52px)" border>
												<el-table-column width="240" label="标题" align="left"
													header-align="center">
													<template slot-scope="scope1">
														<div class="ggt" @click="oncontent(scope1.row.id,scope.row.shop_id)">{{scope1.row.name}}</div>
													</template>
												</el-table-column>
												<el-table-column width="160" prop="create_time_str" label="日期"
													align="center" header-align="center"></el-table-column>
											</el-table>
											<div class="pagediv">
												<el-pagination background layout="prev, pager, next, total" :page-sizes="[20, 30, 50]"
													:current-page.sync="page1" :page-size="pageSize1" :total="total1" v-if="total1 > 0"
													@current-change="handleCurrentChange(scope.row.shop_id)" @size-change="handleSizeChange($event,scope.row.shop_id)">
												</el-pagination>
											</div>
										</div>
										<i slot="reference" class="el-icon-chat-line-round"></i>
									</el-popover>
								</div>
							</template>
						</el-table-column>
						<el-table-column :prop="onprop(x)" v-for="(x,y) in pricesize" :key="y" width="100px"
							align="center" header-align="center">
							<template slot="header" slot-scope="scope">
								<div>{{x.size}}</div>
								<div>{{x.size_ch}}</div>
							</template>
							<template slot-scope="scope">
								<div class="cz" :index="scope.$index" :key="scope.$index">
									<div>{{scope.row[onprop(x)]}}</div>
									<el-input-number :class="pricelist[scope.$index][onprop(x)+'_num'] > 0?'checked':''"
										v-model="pricelist[scope.$index][onprop(x)+'_num']" :min="0"
										:max="scope.row[onprop(x)]" size="small"
										@change="onnumChange($event,scope.row,x,scope.$index)" @blur="blurNumber">
									</el-input-number>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="stock" label="合计" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="agent_price" label="代理价" align="center" header-align="center">
							<template slot-scope="scope">
								<div style="color: #ff4714">{{scope.row.agent_price}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="true_discount" label="折扣" width="60px" align="center" header-align="center" >
						</el-table-column>
						<el-table-column width="110px" align="center" header-align="center">
							<template slot-scope="scope" slot="header">
								<div>下单截止时间</div>
								<div>预反馈时间</div>
							</template>
							<template slot-scope="scope">
								<div>{{scope.row.stop_take_time}}</div>
								<div class="green">{{scope.row.prev_send_delivery_date}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="allocation_rate" label="实际配货率" width="70px" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="free_return_rate" label="免费退货比例+超出扣额" width="180px" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="on_time_rate" label="发货准时率" width="70px" align="center" header-align="center">
						</el-table-column>
						<el-table-column prop="avg_scale" label="平均运费" width="100px" align="center" header-align="center">
						</el-table-column>
						<el-table-column label="多仓发货" width="100px" align="center" header-align="center">
							<template slot-scope="scope">
								<img class="simg" src="../assets/image/dancang.jpg" :title="alt"
									v-if="scope.row.shop_multi_delivery_switch == 0">
								<img class="simg" src="../assets/image/duocang.jpg" :title="alt"
									v-if="scope.row.shop_multi_delivery_switch == 1">
								<div>{{onsecurity(scope.row.security)}}</div>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<div class="detailsbox" ref="xq" style="scroll-margin-top: 54px">
					<div class="imgs">
						<img :src="v" v-for="(v,k) in onimgarr(list.pics)" :key="k">
					</div>
				</div>
			</div>

			<div class="czbox">
				<div class="sj">
					<div>已选<span>{{ts}}</span>件</div>
					<div>共计<span>￥<i>{{onsun(sun)}}</i></span></div>
				</div>
				<div class="btn">
					<el-button type="primary" size="small" @click="oncartSave">加入购物车</el-button>
				</div>
			</div>

			<el-dialog title="" :visible.sync="dialogVisible" width="400px">
				<div class="dialogbox">
					<div class="t">以采购商的身份结算</div>
					<div class="p">申请平台会员，享受更优折扣</div>
					<div class="btn btn1" @click="$router.push('/login')">去登录</div>
					<div class="btn" @click="$router.push('/register')">立即注册</div>
				</div>
			</el-dialog>
		</div>
		<!-- <myfooter></myfooter> -->
		
		<el-dialog title="渠道公告" :visible.sync="show" width="60%" :before-close="onclose4">
			<div class="notice" v-if="show">
				<div class="h1">{{checkobj.name}}</div>
				<div class="time">{{checkobj.create_time_str}}</div>
				<div class="ql-editor" v-html="checkobj.content"></div>
				<div class="myjg">温馨提示：任何脱离本平台的资金交易行为，均与本公司无任何关联，本公司不承担相关责任，请您谨慎操作，谨防风险。</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Detail',
		data() {
			return {
				list: {},
				active: "kc",
				pricelist: [],
				pricesize: [],
				page: 1,
				pageSize: 99999,
				total: 0,
				sku: [],
				ts: 0,
				sun: 0,
				tabflexd: false,
				islogin: false,
				dialogVisible: false,
				
				glist: [],
				page1: 1,
				pageSize1: 20,
				total1: 0,
				checkobj: {},
				show: false,
				
				alt: "选择省份，显示该省份的实际运费标准,“单”表示本渠道单仓发货；“多”表示多仓发货，多件的订单可能分多仓发货，尤其是需要发顺丰到付的！“按件”表示渠道的运费计算方式（因多仓发货，按件收费，若下多件，第1件，按首重付费，第2件开始按续重收费），请注意！"
			}
		},

		inject: ['onimgarr','oncopy'],

		mounted() {
			this.onlist();
			if (this.$cookies.get('token')) {
				this.islogin = true;
				this.oncprice();
			} else {
				this.active = "xq";
			};
			window.addEventListener('scroll', this.detailScroll);
		},

		beforeDestroy() {
			window.removeEventListener('scroll', this.detailScroll);
		},

		methods: {
			onlist(n, v) {
				var obj = {
					id: this.$route.query.id
				};

				this.$axios.post('api/product/list', obj).then(res => {
					if (res.data.code == 0) {
						this.list = res.data.data.list[0];
					}
				}).catch(err => {
					console.log(err)
				})
			},

			oncprice() {
				var obj = {
					from: 1,
					product_id: this.$route.query.id,
					page: this.page,
					limit: this.pageSize
				}

				this.$axios.post('api/user/compare_price', obj).then(res => {
					if (res.data.code == 0) {
						this.pricelist = res.data.data.list;
						this.pricesize = res.data.data.sizes;
						this.total = res.data.data.count;
						this.newarr();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			newarr() {
				this.pricelist.forEach((v, k) => {
					this.pricesize.forEach((x, y) => {
						this.$set(v, 'size_' + x.id + '_num', 0);
					})
				})
			},

			onprop(v) {
				return "size_" + v.id;
			},

			onnumChange(val, o, x, i) {
				this.sku = [];
				this.ts = 0;
				this.sun = 0;
				this.pricelist.forEach((v, k) => {
					this.pricesize.forEach((x, y) => {
						if (v['size_' + x.id + '_num'] == null) {
							this.$set(v, 'size_' + x.id + '_num', 0);
						}
						
						if (v['size_' + x.id + '_num'] != 0) {
							var obj = {};
							obj.shop_id = v.shop_id;
							obj.size_id = x.id;
							obj.num = v['size_' + x.id + '_num'];
							this.sku.push(obj);
							this.sun = Number(this.sun + obj.num * v.agent_price);
							this.ts = this.ts + obj.num
						}
					})
				})
			},
			
			blurNumber(e) {
				if (!e.target.value) {
					e.target.value = 0;
				}
			},

			onsun(v) {
				return JSON.parse(JSON.stringify(v)).toFixed(2);
			},

			handleClick(tab, event) {
				this.$nextTick(() => {
					this.$refs[this.active].scrollIntoView({
						behavior: 'smooth', // 平滑滚动
						block: 'start', // 垂直对齐：顶端对齐
						inline: 'nearest' // 水平对齐：最近端
					});
				})
			},

			onxq() {
				this.active = 'xq';
				this.handleClick();
			},

			detailScroll() {
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 获取滑动距离
				if (scrollTop < this.$refs.tab.offsetTop) {
					this.tabflexd = false;
				} else {
					this.tabflexd = true; // 设置fixed定位
				}

				if (scrollTop >= this.$refs.kc.offsetTop && scrollTop < this.$refs.xq.offsetTop) {
					this.active = 'kc';
				}

				if (Math.ceil(scrollTop) >= Number(this.$refs.xq.offsetTop) - 54) {
					this.active = 'xq';
				}
			},

			oncartSave() {
				if (!this.islogin) {
					this.dialogVisible = true;
				} else {
					if (this.sku && this.sku.length == 0) {
						this.$message({
							message: '请至少选择一条商品数据移入到购物车中！',
							type: 'warning'
						});

						return;
					}
					var obj = {};
					obj.product_id = this.$route.query.id;
					obj.sku = JSON.stringify(this.sku);
					this.$axios.post('api/user/cart_save', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('加入购物车成功');
							this.$refs.myheader.onclist();
							this.onlist();
							this.oncprice();
							this.sku = [];
							this.ts = 0;
							this.sun = 0;
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})

					console.log(this.sku);
				}
			},
			
			cellClassName({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				var num = 0;
				if (this.pricesize) {
					num = this.pricesize.length;
				}
			
				if (columnIndex == (num + 5)) {
					if (row.allocation_rate >= 86) {
						return "green"
					} else {
						return 'red'
					}
				}
			
			
				if (columnIndex == (num + 6)) {
					if (row.free_return_rate) {
						if (row.free_return_rate.split(" + ")[0]) {
							if (row.free_return_rate.split(" + ")[0] == '100%') {
								return "green"
							} else {
								return 'red'
							}
						}
					}
				}
			
				if (columnIndex == (num + 7)) {
					if (row.on_time_rate >= 86) {
						return "green"
					} else {
						return 'red'
					}
				}
			},
			
			
			onsecurity(n) {
				if (n == 1) {
					return ''
				}
			
				if (n == 2) {
					return '撕防伪'
				}
			
				if (n == 3) {
					return '不撕防伪'
				}
			},
			
			handleCurrentChange(id) {
				this.ongdd(id);
			},
			
			handleSizeChange(val,id) {
				this.page1 = 1;
				this.pageSize1 = val;
				this.ongdd(id);
			},
			
			ongdd(id) {
				var obj = {};
				obj.shop_id = id;
				obj.page = this.page1;
				obj.limit = this.pageSize1;
				this.$axios.post('api/user/user_shop_notice_list', obj).then(res => {
					if (res.data.code == 0) {
						this.glist = res.data.data.list;
						this.total1 = res.data.data.count;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onhide() {
				this.glist = [];
				this.page1 = 1;
				this.pageSize1 = 20;
				this.total1 = 0;
			},
			
			oncontent(id,sid){
				var obj = {
					shop_id: sid,
					id: id
				};
				this.$axios.post('api/user/user_shop_notice_list', obj).then(res => {
					if (res.data.code == 0) {
						this.checkobj = res.data.data.list[0];
						this.show = true;
						this.$axios.post('api/user/add_user_notice_view_num?id='+id);
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onclose4() {
				this.checkobj = {};
				this.show = false;
			}
			
		},
	}
</script>

<style scoped lang="less">
	.detail {
		min-width: 1200px;
	}
	.h {
		min-height: calc(100vh - 60px);
	}
	.commoditybox {
		// width: 1200px;
		width: 100%;
		border-radius: 10px;
		background-color: #fff;
		margin: 10px auto 30px;
		padding: 20px;
		box-sizing: border-box;
		padding-bottom: 66px;
	}

	.img_textdiv {
		width: 100%;
		display: flex;
		// justify-content: space-between;

		.img_p {
			margin-right: 25px;
			p {
				width: 100%;
				color: #999;
				margin-top: 4px;
				text-align: center;
			}
		}

		.img {
			min-width: 190px;
			border-radius: 14px;
			height: 190px;
			overflow: hidden;
			position: relative;
			width: 190px;
			cursor: pointer;

			img {
				width: 100%;
				height: 100%;
			}

			div {
				background: linear-gradient(0deg, rgba(0, 0, 0, .6), transparent);
				bottom: 0;
				color: #fff;
				font-size: 12px;
				height: 33px;
				left: 0;
				line-height: 33px;
				position: absolute;
				text-align: center;
				width: 100%;
			}
		}

		.textdiv {
			width: 950px;

			.h4 {
				width: 100%;
				color: #333;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-weight: bolder;
				font-size: 20px;
			}

			.jgbox {
				background: #fffbfb;
				border-radius: 8px;
				padding: 17px 20px 23px;
				box-sizing: border-box;
				margin: 10px 0 16px;
				display: flex;
				align-items: flex-end;

				.hyj {
					font-size: 14px;
					color: #666;
					line-height: 22px;
					margin-right: 8px;
					letter-spacing: 3px;

					span {
						color: #ff4714;
						letter-spacing: initial;
						margin-right: 5px;

						i {
							font-size: 24px;
							font-weight: bold;
						}
					}
				}

				.dpj {
					text-decoration-line: line-through;
					color: #999;
					font-size: 14px;
				}

				.zkk {
					border: 1px solid #ff4714;
					border-radius: 4px;
					display: inline-block;
					height: 21px;
					line-height: 21px;
					color: #ff4714;
					margin-left: 24px;
					padding: 0 6px;
					font-size: 12px;
				}
			}

			.parameter {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				margin-bottom: 6px;

				div {
					color: #666;
					font-size: 14px;
					position: relative;
					display: flex;
					align-items: center;

					span {
						color: #333;
						padding-left: 12px;
					}
				}

				div::after {
					background: #d5d9e1;
					content: "";
					display: inline-block;
					height: 16px;
					// position: absolute;
					width: 1px;
					margin: 0 12px;
				}

				div:last-child::after {
					display: none;
				}
			}

			.content {
				span {
					width: 900px;
					// white-space:nowrap;
					// overflow:hidden;
					// text-overflow:ellipsis;

					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					/* 限制文本为2行 */
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: normal;
					/* 允许换行 */
				}
			}
		}
	}

	.tabdiv {
		width: 100%;
		height: 54px;
		background-color: #fff;
	}

	.flexd {
		position: fixed;
		top: 0;
		z-index: 101;
	}

	.dtablebox {
		width: 100%;
	}

	/deep/ .el-tabs__item {
		font-size: 16px;
		font-weight: 500;
		color: #909399;
	}

	/deep/ .el-tabs__item.is-active {
		color: #F65730;
	}


	/deep/ .el-tabs__nav-wrap::after {
		display: none;
	}

	.detailsbox {
		width: 100%;
		display: flex;
		justify-content: center;
		// margin-top: 16px;

		.imgs {
			width: 790px;
			display: flex;
			flex-direction: column;

			img {
				width: 100%;
			}
		}
	}

	.cz {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.cz .el-input-number {
		transform: scale(0.9);
	}

	.cz {
		/deep/ .el-input--small .el-input__inner {
			height: 32px;
			line-height: 32px;
		}

		/deep/ .el-input-number--small .el-input__inner {
			padding-left: 20px;
			padding-right: 20px;
		}

		/deep/ .el-input-number--small {
			width: 80px;
		}

		/deep/ .el-input-number__decrease {
			width: 20px;
		}

		/deep/ .el-input-number__increase {
			width: 20px;
		}
	}

	.czbox {
		width: 420px;
		height: 62px;
		position: fixed;
		bottom: 5px;
		left: 50%;
		margin-left: -210px;
		border-radius: 10px;
		box-shadow: 0 0 20px #94949426;
		padding: 15px 20px;
		box-sizing: border-box;
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		z-index: 100;

		.sj {
			font-size: 14px;
			color: #333;
			display: flex;
			align-items: self-end;

			span {
				color: #ff4714;

				i {
					font-size: 20px;
				}
			}

			div:nth-child(2) {
				line-height: 22px;
				margin-left: 20px;
			}
		}

		.btn {}

	}

	.simg {
		width: 16px;
		height: 16px;
	}

	.dialogbox {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

		.t {
			color: #111;
			font-size: 16px;
			font-weight: 700;
			line-height: 24px;
		}

		.p {
			color: #666;
			font-size: 12px;
			line-height: 16px;
			margin-top: 10px;
			margin-bottom: 20px;
		}

		.btn {
			border-radius: 2px;
			cursor: pointer;
			font-size: 16px;
			line-height: 20px;
			text-align: center;
			width: 250px;
			margin: 10px auto;
			border: 1px solid #ccc;
			color: #333;
			padding: 9px;
		}

		.btn1 {
			background: linear-gradient(135deg, #ff4714, #ff7d2d);
			border: 1px solid #ff4714;
			color: #fff;
		}
	}
	
	/deep/ .green {
		color: green !important;
	}
	
	/deep/ .red {
		color: red !important;
	}
	
	.is {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 6px;
	
		img {
			width: 24px;
			height: 24px;
			cursor: pointer;
			margin: 0 5px;
		}
	
		i {
			font-size: 20px;
			cursor: pointer;
			margin: 0 5px;
		}
	}
	
	.ggbox {
		width: 100%;
		height: 350px;
	}
	
	.ggt {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		cursor: pointer;
	}
	
	.notice {
		.h1 {
			width: 100%;
			font-size: 20px;
			text-align: center;
			font-weight: bold;
			color: #303133;
		}
		
		.time {
			width: 100%;
			font-size: 14px;
			text-align: center;
			color: #666;
			margin-top: 12px;
		}
	}
	
	.green {
		color: green;
	}
</style>



// WEBPACK FOOTER //
// src/components/detail.vue